import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <div className="mx-auto flex w-full flex-col items-center justify-center px-4 py-24 text-center md:px-6 md:py-32">
        <span className="font-heading text-7xl font-black text-primary-200 md:text-9xl">404</span>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          页面走丢了
        </h1>
        <p className="mt-3 max-w-md text-sm text-foreground-500">
          你访问的页面不存在或已被移除，试试回到首页或浏览电影分类。
        </p>
        <p className="mt-2 font-mono text-xs text-foreground-400">{location.pathname}</p>
        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/movies"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            <i className="ri-compass-3-line"></i>
            电影分类
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}